module.exports = __webpack_public_path__ + "static/img/Otp.3f6ba55.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/partners/Otp.png
// module id = D9Hl
// module chunks = 0